import React, { PureComponent } from 'react';
import ExternalLink from '../ExternalLink';
import InternalLink from '../InternalLink';

export default class VariableLink extends PureComponent {
    render() {
        const { to } = this.props;

        if( to.match( /^http/ ) && !to.match( /desirelist\.com/ ) ) {
            return ( <ExternalLink { ...this.props } /> );
        }
        return (
            <InternalLink { ...this.props } />
        );
    }
}
VariableLink.defaultProps = {
    to: '#',
    children: null,
    className: '',
    arrowProps: {},
};
